import React from "react";

function circularPlus(props) {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" >
      <circle cx="10" cy="10" r="10" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M14.4001 10.5999H5.6001V9.3999H14.4001V10.5999Z" fill="#FFF" />
      <path fillRule="evenodd" clipRule="evenodd" d="M9.4001 14.4001L9.4001 5.6001L10.6001 5.6001L10.6001 14.4001L9.4001 14.4001Z" fill="#FFF" />
    </svg>

    )
}
export default circularPlus;